<form [formGroup]="partnerPersoonlijkFg">
  <div class="row col-auto">
    <snelstart-ui-text-form-control (change)="saveForm()"
                                    class="custom-input-150"
                                    formControlName="voorletters"
                                    id="voorletters"
                                    label="Voorletter(s)"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control (change)="saveForm()"
                                    class="custom-input-125"
                                    formControlName="tussenvoegsels"
                                    id="tussenvoegsels"
                                    label="Tussenvoegsel"
    >
    </snelstart-ui-text-form-control>
  </div>
  <div class="col-auto">
    <snelstart-ui-text-form-control (change)="saveForm()"
                                    [required]=true
                                    class="custom-input-250"
                                    formControlName="achternaam"
                                    id="achternaam"
                                    label="Achternaam"
    >
    </snelstart-ui-text-form-control>
  </div>
  <div class="col-auto">
    <snelstart-ui-date-form-control (change)="saveForm()"
                                    [required]=true
                                    class="custom-input-250"
                                    formControlName="geboortedatum"
                                    id="geboortedatum"
                                    label="Geboortedatum"
                                    placeholder="dd-mm-jjjj"
    >
    </snelstart-ui-date-form-control>
  </div>
  <div class="col-auto">
    <snelstart-ui-bsn-form-control (change)="saveForm()"
                                   [required]=true
                                   class="custom-input-250"
                                   formControlName="bsn"
                                   id="bsn"
                                   label="Burgerservicenummer"
    >
    </snelstart-ui-bsn-form-control>
  </div>
  @if (this.incomeTaxEntity.aangifte?.partnerAangifte?.biljetSoort === "C") {
    <div class="col-auto">
      <snelstart-ui-select-form-control (change)="saveForm()"
                                        [options]="optionsLandcodesMetNld"
                                        class="custom-input-250"
                                        formControlName="landCodeNationaliteit"
                                        id="nationaliteit"
                                        label="Nationaliteit"
      >
      </snelstart-ui-select-form-control>
    </div>
  }
</form>
@if (this.incomeTaxEntity.aangifte?.biljetSoort === "C") {
  <form [formGroup]="woonlandFg">
    <div class="col-auto">
      <snelstart-ui-select-form-control (change)="saveForm()"
                                        [options]="optionsLandcodesZonderNld"
                                        class="custom-input-250"
                                        formControlName="landCodeWoonland"
                                        id="landCodeWoonland"
                                        label="Woonland"
      >
      </snelstart-ui-select-form-control>
    </div>
    @if (woonlandFg.get('woonlandVoldoetVoorKwalificatie')?.getRawValue()) {
      <div class="col-auto">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                          id="belastingplichtigeVoldoetAanVoorwaardenKwalificatie"
                                          label="Kwalificerend belastingplicht"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </form>
}

<!-- gezamenlijke aangifte-->
@if (showGezamenlijkeAangifte()) {
  <form [formGroup]="gezamenlijkeAangifteFg">
    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="custom-input-250"
                                      formControlName="gezamenlijkeAangifte"
                                      label="Gezamenlijke aangifte"
    >
    </snelstart-ui-select-form-control>
  </form>
}

<!-- indien niet gezamenlijk aangifte -->
@if (incomeTaxEntity.aangifte?.gezamenlijkeAangifte === false && incomeTaxEntity.aangifte?.biljetSoort !== 'C') {
  <snelstart-venture-fiscaal-feature-iack-info></snelstart-venture-fiscaal-feature-iack-info>
}

@if (!partnerStaatInSnelStartRelatielijst && incomeTaxEntity.aangifte?.gezamenlijkeAangifte) {
  <div class="pt-2">
    <snelstart-ui-alert type="warning">
      Let op! Bij een fiscaal partner is belangrijk dat deze persoon als <b>afzonderlijke klant</b> is aangemaakt
      in de
      klantenlijst van SnelStart. Is dat niet het geval? Maak dan de partner aan als nieuwe klant, vul het
      burgerservicenummer in (bsn) en geef aan dat
      er sprake is van belastingplicht voor de inkomstenbelasting. Op deze manier kun
      je voor partner (service)berichten ontvangen, uitstel aanvragen en ook via de partner (klant) naar de
      gezamenlijke aangifte toe.
    </snelstart-ui-alert>
  </div>
}

